import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'
import { Button } from './ui/button'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  message?: string
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(error: unknown): State {
    return {
      hasError: true,
      // NO incluir detalles PHI. Mensaje genérico + código.
      message: error instanceof Error ? error.name : 'render_error',
    }
  }

  componentDidCatch(_error: unknown, _errorInfo: ErrorInfo): void {
    // Deliberadamente NO loggeamos `error` ni `errorInfo` aquí:
    // stack traces pueden contener PHI en props/state. En F2+ integrar Sentry con scrubber.
  }

  reset = () => {
    this.setState({ hasError: false, message: undefined })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-dvh flex-col items-center justify-center bg-slate-50 px-6 text-center">
          <div className="max-w-md rounded-lg border border-slate-200 bg-white p-8 shadow-sm">
            <h1 className="text-xl font-semibold text-slate-900">Algo salió mal</h1>
            <p className="mt-2 text-sm text-slate-600">
              Ocurrió un error inesperado al renderizar la pantalla. El equipo técnico ha sido
              notificado. Puedes intentar recargar.
            </p>
            <p className="mt-3 font-mono text-xs text-slate-400">
              Código: {this.state.message ?? 'unknown'}
            </p>
            <div className="mt-6 flex justify-center gap-2">
              <Button
                variant="outline"
                onClick={() => {
                  this.reset()
                  window.location.href = '/'
                }}
              >
                Ir al inicio
              </Button>
              <Button onClick={() => window.location.reload()}>Recargar</Button>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
